import React from 'react';
import PropTypes from 'prop-types';
import { navigateTo } from 'gatsby-link';
import Img from 'gatsby-image';
import { Button, Container } from 'reactstrap';

import './Jumbotron.scss';

const Jumbotron = props => {
  const { children, title, subtitle, buttonText, link } = props;

  return (
    <div className="jumbo">
      {props.children}
      <Container fluid>
        <center>
          <h1 className="display-3">{title}</h1>
          <p className="lead">{subtitle}</p>
          <br />
          <br />
          <p className="lead">
            <Button color="primary" onClick={() => navigateTo(link)}>
              {buttonText}
            </Button>
          </p>
        </center>
      </Container>
    </div>
  );
};

Jumbotron.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonText: PropTypes.string,
};

export default Jumbotron;



// WEBPACK FOOTER //
// ./src/components/ui/img/Jumbotron.js